const jQ = jQuery.noConflict();
const circleWrapper = jQ('.animated__circle');
const line = jQ('.animated__line');
const wrapper = jQ('.animated__wrapper');
const lastWrapper = wrapper.last();
lastWrapper.addClass('hide-line');
const windowHeight = jQ(window).height();
const halfHeight = windowHeight * 0.5;
let lastScrollTop = 0;


function drawLine(el, index) {
    if (index === 0) {
        el.find(circleWrapper).addClass('animated__circle--animate');
        el.find(line).addClass('animated__line--animate');
        const elLine = el.find(line);
        const height = elLine.closest('.animated__wrapper').height();
        const speed = height / 440;
        elLine.css({
            animationDuration: `${speed}s`,
        });


        elLine.one('webkitAnimationEnd msAnimationEnd animationend', () => {
            elLine.addClass('finished');
        });
    } else {
        const prevEl = wrapper.eq(index - 1).find('.animated__line--animate');
        if (!(wrapper.last().find('.animated__circle--animate').length > 0)) {
            const interval = setInterval(checkAnimation, 1);
            function checkAnimation() { // eslint-disable-line

                if (prevEl.hasClass('finished')) {
                    el.find(circleWrapper).addClass('animated__circle--animate');
                    el.find(line).addClass('animated__line--animate');
                    const elLine = el.find(line);
                    const height = elLine.closest('.animated__wrapper').height();
                    const speed = height / 440;
                    elLine.css({
                        animationDuration: `${speed}s`,
                    });
                    elLine.one('webkitAnimationEnd msAnimationEnd animationend', () => {
                        elLine.addClass('finished');
                    });
                    clearInterval(interval);
                }
            }
        }
    }
}

function startDraw() {
    wrapper.each((index, element) => {
        const thisTop = jQ(element).offset().top - jQ(window).scrollTop();

        // Check if this element is in the interested viewport
        if (thisTop <= halfHeight) {
            drawLine(jQ(element), index);
        }
    });
}

function stopDraw() {
    wrapper.each((index, element) => {
        jQ(element).find('.animated__line--animate').css('-webkit-animation-play-state', 'paused');
    });
}
function activateDraw() {
    wrapper.each((index, element) => {
        jQ(element).find('.animated__line--animate').css('-webkit-animation-play-state', 'inherit');
    });
}

function initDraw() {
    const st = jQ(window).scrollTop();

    if (st > lastScrollTop) {
        activateDraw();
        startDraw();
    } else {
        stopDraw();
    }
    lastScrollTop = st;
}

export default initDraw;
